import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "../styles/main.css";
import Header from "./Header";
import Footer from "./Footer";
import { CatalogMetaProvider } from "../context/CatalogMetaContext";

const Catalog = lazy(() => import("../pages/Catalog"));
const Article = lazy(() => import("../pages/Article"));

function AppRouter() {
  return (
    <>
      <div className="min-h-screen bg-light flex flex-col">
        <Router>
          <CatalogMetaProvider>
            <Header />
            <Routes>
              <Route
                path="/:type?/:category?/:subcategory?"
                element={
                  <Suspense fallback={<></>}>
                    <div className="flex flex-col items-center flex-1">
                      <Catalog />
                    </div>
                  </Suspense>
                }
              />
              <Route
                path="/p/:ref"
                element={
                  <Suspense fallback={<></>}>
                    <div className="flex flex-col items-center flex-1">
                      <Article />
                    </div>
                  </Suspense>
                }
              />
            </Routes>
          </CatalogMetaProvider>
        </Router>
      </div>
      <Footer />
    </>
  );
}

export default AppRouter;
